// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-title {
  text-align: center;
}

.modalContent {
  min-height: 100%;
}

ion-icon {
  font-size: 1.3rem;
}

ion-content {
  --ion-background-color: rgb(247, 247, 247);
}

ion-searchbar {
  --box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  --border-radius: 15px;
  --background: white;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/address/list-address/list-address.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAGA;EACI,0CAAA;AAAJ;;AAGA;EACI,mDAAA;EACA,qBAAA;EACA,mBAAA;AAAJ","sourcesContent":["ion-title {\r\n    text-align: center;\r\n}\r\n\r\n.modalContent {\r\n    min-height: 100%;\r\n}\r\n\r\nion-icon {\r\n    font-size: 1.3rem;\r\n}\r\n\r\n\r\nion-content {\r\n    --ion-background-color: rgb(247, 247, 247);\r\n}\r\n\r\nion-searchbar {\r\n    --box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\r\n    --border-radius: 15px;\r\n    --background: white;\r\n\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
